<table class="table table-borderless table-centered align-middle table-nowrap small">
  <thead class="text-muted table-light">
    <tr class="align-middle">
      <th scope="col" class="py-2">Country</th>
      <th scope="col" class="py-2 align-middle text-end">
        <span class="d-inline-block" style="line-height: 1.2;">Usage Days</span>
      </th>
      <th scope="col" class="py-2 align-middle text-end">
        <span class="d-inline-block" style="line-height: 1.2;">Total Usage</span>
      </th>
      <th scope="col" class="py-2 align-middle text-end">
        <span class="d-inline-block" style="line-height: 1.2;">Total Spend £</span>
      </th>
    </tr>
  </thead>
  <tbody>
    @for (data of countryUsageSummary; track $index) {
      <tr class="align-middle">
        <td class="py-2">
          <img width="16" [src]="data.countryFlag" class="me-1" />
          <span>{{ data.country }}</span>
        </td>
        <td class="text-end py-2">{{ data.usageDays }}</td>
        <td class="text-end py-2">{{ data.totalUsage }}</td>
        <td class="text-end py-2">
          <span class="text-success">{{ data.totalCostWithCurrencySymbol }}</span>
        </td>
      </tr>
    }
  </tbody>
</table>
